import script from "./UpcomingAppointments.vue?vue&type=script&setup=true&lang=ts"
export * from "./UpcomingAppointments.vue?vue&type=script&setup=true&lang=ts"

export default script